// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM18 11V8H16V11H18ZM13 13V10H11V13H13ZM8 18V12H6V18H8ZM18 18V13H16V18H18ZM13 18V15H11V18H13Z"}}]};

const AnalyticsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'analytics-filled',
    ref,
    icon: element,
  },
));

AnalyticsFilledIcon.displayName = 'AnalyticsFilledIcon';

export default AnalyticsFilledIcon;
